var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "eleBillForm",
      staticClass: "step4YzCom",
      attrs: {
        "label-width": "120px",
        rules: _vm.eleBillFormRule,
        model: _vm.eleBillForm,
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              staticClass: "cainiaoTab",
              attrs: { stretch: true },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "有赞店铺账号授权", name: "shop" } },
                [
                  _c("div", { staticClass: "tab-header" }, [
                    _c("img", {
                      staticClass: "icon-company-box",
                      attrs: {
                        src: require("@/assets/images/ecommercepng/icon_dianpu_YZ.png"),
                        alt: "",
                      },
                    }),
                  ]),
                  _vm.yzShopList.length > 0 ||
                  (_vm.yzShopList.length <= 0 && _vm.loading)
                    ? _c(
                        "div",
                        { staticClass: "tab-bottom" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "有赞店铺", prop: "shop" } },
                            [
                              _c(
                                "div",
                                { staticClass: "y-f" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择店铺类型" },
                                      on: { change: _vm.changeShop },
                                      model: {
                                        value: _vm.eleBillForm.shop,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.eleBillForm, "shop", $$v)
                                        },
                                        expression: "eleBillForm.shop",
                                      },
                                    },
                                    _vm._l(_vm.yzShopList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.MallName,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                      on: { click: _vm.storeAuthorization },
                                    },
                                    [_vm._v("添加新店铺")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "网点发货地址" } },
                            [
                              _vm.filterOriginList.length > 0 || _vm.loading
                                ? _c(
                                    "div",
                                    { staticClass: "y-f" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "请选择发货地址",
                                          },
                                          model: {
                                            value: _vm.eleBillForm.faceId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.eleBillForm,
                                                "faceId",
                                                $$v
                                              )
                                            },
                                            expression: "eleBillForm.faceId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.filterOriginList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.addressInfo,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                          on: { click: _vm.jumpYz },
                                        },
                                        [_vm._v("添加新发货地址")]
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "y-bk-fff6a0",
                                      staticStyle: { padding: "5px" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "y-fl-18",
                                          staticStyle: { margin: "0" },
                                        },
                                        [
                                          _vm._v(
                                            "未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                          _vm.filterOriginList.length <= 0 && !_vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "y-fc-4C84FF y-c-p y-f-r y-fs-14",
                                },
                                [
                                  _c("span", { on: { click: _vm.jumpYz } }, [
                                    _vm._v("开通电子面单"),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "y-ml-10",
                                      on: { click: _vm.storeAuthorization },
                                    },
                                    [_vm._v("绑定电子面单账号")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "y-ml-10",
                                      on: { click: _vm.howHelpAuth },
                                    },
                                    [_vm._v("查看教程")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "tab-bottom y-fs-14 clearfix" },
                        [
                          _c("p", { staticClass: "y-fc-000 y-fl-18" }, [
                            _vm._v(
                              " 您还未绑定任何小红书店铺，请点击<去绑定>绑定您的小红书店铺，或点击<查看教程>，按步骤进行操作。 "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "y-fc-4C84FF y-c-p y-f-r" },
                            [
                              _c(
                                "span",
                                { on: { click: _vm.storeAuthorization } },
                                [_vm._v("去绑定")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "y-ml-10",
                                  on: { click: _vm.howHelpAuth },
                                },
                                [_vm._v("查看教程")]
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }